import { clsx } from 'clsx'

import { Post } from '@tribeplatform/gql-client/types'
import { PostActionBar } from '@tribeplatform/react-components/Post'

import type { StaticField } from '../../Views/types.js'

interface Props {
  post: Post
  highlighted: boolean
  stretchX: string
  buttonVariant: StaticField['settings']['buttonVariant']
  fullWidth: boolean
}
export const ActionBar = ({
  post,
  highlighted,
  stretchX,
  buttonVariant,
  fullWidth,
}: Props) => {
  return (
    <div
      className={clsx(
        'flex space-s-2 text-content-subdued items-center min-w-0',
        highlighted && 'ring-2 rounded-sm ring-offset-surface ring-focused',
        stretchX,
      )}
    >
      {buttonVariant === 'icon' && (
        <PostActionBar
          post={post}
          isLastChild={false}
          style={{ padding: 0 }}
          showText={false}
          fullWidth={fullWidth}
        />
      )}
      {buttonVariant === 'text' && (
        <PostActionBar
          post={post}
          isLastChild={false}
          style={{ padding: 0 }}
          showIcon={false}
          fullWidth={fullWidth}
        />
      )}
      {buttonVariant === 'iconText' && (
        <PostActionBar
          post={post}
          isLastChild={false}
          style={{ padding: 0 }}
          fullWidth={fullWidth}
        />
      )}
    </div>
  )
}
